import * as React from 'react';
import { useState } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
/////
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

/////

// export default function ProjectCard({
//   alt,
//   imageUrl,
//   title,
//   description,
//   githubUrl,
//   pageUrl,
//   details,
// }) {
//   /////
//   const [open, setOpen] = React.useState(false);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };

//   /////

//   {
//     return (
//       <>
//         <Card sx={{ maxWidth: 400 }}>
//           <CardMedia
//             component="img"
//             alt={alt}
//             height="200"
//             image={imageUrl}
//             onClick={handleClickOpen}
//           />
//           <CardContent>
//             <Typography gutterBottom variant="h5" component="div">
//               {title}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {description}
//             </Typography>
//           </CardContent>
//           <CardActions>
//             <Button href={githubUrl} target="_blank" size="small">
//               Github Repo
//             </Button>
//             <Button href={pageUrl} target="_blank" size="small">
//               Visit Page
//             </Button>
//           </CardActions>
//         </Card>
//         <BootstrapDialog
//           onClose={handleClose}
//           aria-labelledby="customized-dialog-title"
//           open={open}
//         >
//           <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
//             {title}
//           </DialogTitle>
//           <IconButton
//             aria-label="close"
//             onClick={handleClose}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <DialogContent dividers>
//             <Typography gutterBottom>{details}</Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button href={pageUrl} target="_blank" autoFocus>
//               Visit Page
//             </Button>
//           </DialogActions>
//         </BootstrapDialog>
//       </>
//     );
//   }
// }

export default function ProjectCard({
  alt,
  imageUrl,
  title,
  description,
  githubUrl,
  pageUrl,
  details,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card sx={{ maxWidth: 400 }}>
        <CardMedia
          component="img"
          alt={alt}
          height="200"
          image={imageUrl}
          onClick={handleClickOpen}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button href={githubUrl} target="_blank" size="small">
            Github Repo
          </Button>
          <Button href={pageUrl} target="_blank" size="small">
            Visit Page
          </Button>
        </CardActions>
      </Card>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>{details}</Typography>
        </DialogContent>
        <DialogActions>
          <Button href={pageUrl} target="_blank" autoFocus>
            Visit Page
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
